import { createSelector } from '@reduxjs/toolkit'
import type { RootState } from 'app'

export const getContractorsState = (state: RootState) =>
  state.common.contractors

export const getContractors = createSelector(
  getContractorsState,
  state => state.contractors
)

export const getLoadingState = createSelector(
  getContractorsState,
  state => state.loadingState
)

export const getAddContractorError = createSelector(
  getContractorsState,
  state => state.addContractorError
)

export const getContractorsCount = createSelector(
  getContractorsState,
  state => state.contractorsCount
)

export const getAddContractorSuccessDialogState = createSelector(
  getContractorsState,
  state => state.dialogs.addContractorSuccessDialogState
)

export const getAddContactDialogState = createSelector(
  getContractorsState,
  state => state.dialogs.addContactDialogState
)

export const getAddContractorDialogState = createSelector(
  getContractorsState,
  state => state.dialogs.addContractorDialogState
)

export const getAreThereNoResults = createSelector(
  getContractorsState,
  state => state.areThereNoResults
)

export const getContractorContacts = createSelector(
  getContractorsState,
  state => state.contractorContacts
)

export const getContractorDetails = createSelector(
  getContractorsState,
  state => state.contractorDetails
)

export const getContractorDialogTaxNumberFieldState = createSelector(
  getAddContractorDialogState,
  state => state.taxNumberField
)

export const getSelectedContractors = createSelector(
  getContractorsState,
  state => state.autocomplete.selectedContractors
)

export const getContractorsOptions = createSelector(
  getContractors,
  contractors =>
    contractors.map(contractor => ({
      title: contractor.name,
      value: contractor.id,
    }))
)

export const getEditContractorContactState = createSelector(
  getContractorsState,
  state => state.editContractorContact
)

export const getContractorContactStatusState = createSelector(
  getContractorsState,
  state => state.getContractorContactStatus
)
